import { ColumnHelper } from "@tanstack/react-table";
import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";
import { Typography } from "PFComponents/typography";

import { AvailabilityCell } from "./availability_cell";

type CreateAvailabilityColumnArgs = {
  headerLabel: string;
};

export const createAvailabilityColumn = (
  columnHelper: ColumnHelper<ShortlistWithScores>,
  { headerLabel }: CreateAvailabilityColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id: "availability",
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => <AvailabilityCell shortlist={info.getValue()} />,
    sortingFn: (rowA, rowB) => {
      const scoreA = rowA.original.scores?.availabilityScore ?? 0;
      const scoreB = rowB.original.scores?.availabilityScore ?? 0;
      return scoreA - scoreB;
    },
    sortUndefined: "last",
    size: 40
  });
